// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__lrj1S","spinner":"Spinner_spinner__2_Kv4","spin":"Spinner_spin__aRz7X"};